import { useAuthStore } from '@/state/auth';
import { useNavigationStore } from '@/state/navigation';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedAccessProps {
  children: React.ReactNode;
}

export function ProtectedAccess({ children }: ProtectedAccessProps) {
  const { isAuthenticated, user, token, clearAuth } = useAuthStore();
  const { clearHistory } = useNavigationStore();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated || !user || !token) {
      // Force-clear auth and navigation history if state is invalid
      clearAuth();
      clearHistory();
    }
  }, [isAuthenticated, user, token, clearAuth, clearHistory]);

  if (!isAuthenticated || !user || !token) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedAccess;


